import { removeEscapeSequence } from 'utils/string';

import { MESSAGES_ACTION_TYPE } from 'store/global/actions';

const initialState = [];

const messagesReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case MESSAGES_ACTION_TYPE.SHOW_MESSAGE: {
      const formattedMessage = removeEscapeSequence(payload.message);

      if (!!payload.id && state.some(i => i.id === payload.id)) {
        return state;
      }

      return [...state, { ...payload, message: formattedMessage }];
    }

    case MESSAGES_ACTION_TYPE.HIDE_MESSAGE: {
      return state.filter(({ id }) => id !== payload);
    }

    default: {
      return state;
    }
  }
};

export default messagesReducer;
